import { apiCall, apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";

export const createVehicleApi = async (data) => {
  return await apiCall("POST", `vehicle`, data);
};

export const getVehicleDetailsApi = async (vehicleId) => {
  const response = await apiCall("GET", `vehicle/get/${vehicleId}`);
  return response.data;
};

export const getVehicleCustomer = async (vehicleNumber) => {
  const data = {
    vehicle_number: vehicleNumber,
  };
  const response = await apiCall("POST", `get_vehicle_customers`, data);
  return response.data;
};

export const getTransporterListApi = async (term) => {
  return await apiCall("GET", `get_transporters?term=${term}`);
};

export const getVendorListApi = async (term) => {
  return await apiCall("GET", `get_vendors?term=${term}`);
};

export const getCustomerListApi = async (term) => {
  return await apiCall("GET", `get_customers?term=${term}`);
};

export const getLocationFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_location`);
  return response.data;
};

export const getDepartmentFilterApi = async () => {
  const response = await apiCallAdmin("GET", `get_department`);
  return response.data;
};
export const gateOutVehicleApi = async (data) => {
  return await apiCall("POST", `vehicle_gate_out`, data);
};

export const getVehicleGatePassApi = async (id) => {
  return await apiCall("GET", `vehicle_gate_pass/${id}`);
};

export const downloadVehicleGatePassBlobApi = async (fileUrl) => {
  return await apiCallGeneric("GET", fileUrl, null, { responseType: "blob" });
};
